import { Action } from "../../../libs/redux/action";
import { ZohoState } from "../state";
import {
    ZOHO_PHASE_FILE,
    ZOHO_PHASE_EXTRA_FILE,
    ZOHO_PHASE_FILE_DONE,
    ZOHO_PHASE_EXTRA_FILE_DONE,
    ZOHO_PHASE_FOUR,
    ZOHO_PHASE_FOUR_DONE,
    ZOHO_PHASE_ONE,
    ZOHO_PHASE_ONE_DONE,
    ZOHO_PHASE_THREE,
    ZOHO_PHASE_THREE_DONE,
    ZOHO_PHASE_TWO,
    ZOHO_PHASE_TWO_DONE,
} from "../constants";
import { PhaseOneParameters } from "../../../libs/zoho/models/PhaseOne";
import { PhaseTwoParameters } from "../../../libs/zoho/models/PhaseTwo";
import { PhaseThreeParameters } from "../../../libs/zoho/models/PhaseThree";
import { PhaseFourParamaters } from "../../../libs/zoho/models/PhaseFour";
import {
    PhaseFileParameters,
    PhaseExtraFileParameters,
} from "../../../libs/zoho/models/PhaseFile";

export class ZohoPhaseOne extends Action<void | PhaseOneParameters, ZohoState> {
    readonly type = ZOHO_PHASE_ONE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseOneDone extends Action<
    { zohoId: string } | Error,
    ZohoState
> {
    readonly type = ZOHO_PHASE_ONE_DONE;
    reducer(state: ZohoState): ZohoState {
        if (this.error) {
            return {
                ...state,
            };
        }

        const { zohoId } = this.payload as { zohoId: string };

        return {
            ...state,
            zohoId,
        };
    }
}

export class ZohoPhaseTwo extends Action<PhaseTwoParameters, ZohoState> {
    readonly type = ZOHO_PHASE_TWO;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseTwoDone extends Action<void | Error, ZohoState> {
    readonly type = ZOHO_PHASE_TWO_DONE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseThree extends Action<PhaseThreeParameters, ZohoState> {
    readonly type = ZOHO_PHASE_THREE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseThreeDone extends Action<void | Error, ZohoState> {
    readonly type = ZOHO_PHASE_THREE_DONE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseFour extends Action<PhaseFourParamaters, ZohoState> {
    readonly type = ZOHO_PHASE_FOUR;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseFourDone extends Action<void | Error, ZohoState> {
    readonly type = ZOHO_PHASE_FOUR_DONE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseFile extends Action<PhaseFileParameters, ZohoState> {
    readonly type = ZOHO_PHASE_FILE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseFileExtra extends Action<
    PhaseExtraFileParameters,
    ZohoState
> {
    readonly type = ZOHO_PHASE_EXTRA_FILE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseFileDone extends Action<void | Error, ZohoState> {
    readonly type = ZOHO_PHASE_FILE_DONE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}

export class ZohoPhaseFileExtraDone extends Action<void | Error, ZohoState> {
    readonly type = ZOHO_PHASE_EXTRA_FILE_DONE;
    reducer(state: ZohoState): ZohoState {
        return {
            ...state,
        };
    }
}
